import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';
import { OBJECT_RISK_CATEGORY_NOT_EXTREMELY_HIGH_RISK } from '../../MainModule/constants/notices';
import { addNoticeAction } from '../actions/NoticeActions';

export const addNoticeObjectRiskCategory = () =>
  addNoticeAction({
    renderContent: OBJECT_RISK_CATEGORY_NOT_EXTREMELY_HIGH_RISK,
    noticeType: NoticeTypesEnum.ERROR,
    messageType: MessageTypesEnum.KNM_FILE_SIZE,
  });
